import { generatePath, useNavigate, useParams } from 'react-router-dom'
import ButtonIconGroup from '../components/ButtonIconGroup'
import { EditorMode } from './editor-types'
import { DesktopIcon, IPadIcon, IPhoneIcon, ResponsiveIcon } from '../icons/Icons'
import { HUB_THEMES_PATH } from '../libs/routerPaths'
import { BackButton, PageHeader } from '@/ui'
import { PageRead, WebsiteRead } from '../api/dashboard'
import { useTranslation } from 'react-i18next'
import { Button, Select } from '@dashboard/ui'

export const HubEditorHeader = (props: {
  webSite: WebsiteRead
  selectedPage: PageRead | null
  setSelectedPage: (page: PageRead | null) => void
  editorMode: EditorMode
  saveClick: () => void
  previewClick: () => void
  setEditorMode: (value: EditorMode) => void
  previewMode: boolean
  pages: PageRead[]
}) => {
  const { t } = useTranslation()
  const { companyId, gameId } = useParams() as { companyId: string; gameId: string }
  const sortedPages = props.pages.sort(a => (a.slug === 'home' ? -1 : 1))
  const navigate = useNavigate()

  return (
    <PageHeader
      className="mx-2"
      variant="bordered"
      extraCenter={
        !props.previewMode && (
          <div className="w-[272px]">
            <Select
              value={props.selectedPage?.id || null}
              onChange={v => {
                props.setSelectedPage(props.pages.find(it => it.id == v) || null)
              }}
              items={[
                ...sortedPages.map(it => ({
                  children: it.title,
                  value: it.id,
                })),
              ]}
              datatestid="hub-editor/page-select"
            />
          </div>
        )
      }
      extra={
        <div className="flex items-center gap-2">
          {!props.previewMode && (
            <ButtonIconGroup
              items={[
                { icon: <IPhoneIcon />, value: EditorMode.Mobile },
                { icon: <IPadIcon />, value: EditorMode.Tablet },
                { icon: <DesktopIcon />, value: EditorMode.Desktop },
                { icon: <ResponsiveIcon />, value: EditorMode.Responsive },
              ]}
              value={props.editorMode}
              onSelected={value => props.setEditorMode(value as unknown as EditorMode)}
            />
          )}
          <Button variant="outline" size="md" color="primary" onClick={props.previewClick}>
            {t(props.previewMode ? 'hub-editor.back-to-edit' : 'hub-editor.preview')}
          </Button>

          {!props.previewMode && (
            <Button variant="default" size="md" color="primary" onClick={props.saveClick}>
              {t('Save')}
            </Button>
          )}
        </div>
      }
    >
      {!props.previewMode && (
        <BackButton
          className={`min-w-[300px]`}
          icon={
            props.webSite && (
              <img
                className="size-[36px] rounded-md border border-border-primary"
                src={props.webSite.game.logo_url}
                alt={props.webSite.title}
              />
            )
          }
          text={props.webSite.title}
          onClick={() => navigate(generatePath(HUB_THEMES_PATH, { companyId, gameId }))}
        />
      )}
    </PageHeader>
  )
}
